import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import FormWrapper from '../FormWrapper';

const LoginForm = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    identifier: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.identifier || !form.password) {
      setError('لطفاً تمام فیلدها را پر کنید');
      return;
    }
    setLoading(true);
    setError('');

    try {
      const loginEndpoint = 'https://api.neontradepro.com/auth/login';
      const loginPayload = form.identifier.includes('@')
        ? { email: form.identifier, password: form.password }
        : { username: form.identifier, password: form.password };

      const loginResponse = await fetch(loginEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(loginPayload)
      });

      const loginData = await loginResponse.json();
      if (!loginResponse.ok) {
        throw new Error(loginData.detail || 'نام کاربری یا رمز عبور اشتباه است');
      }

      const { access_token } = loginData;
      if (!access_token) {
        throw new Error('توکن دسترسی از سرور دریافت نشد.');
      }
      
      localStorage.setItem('token', access_token);
      localStorage.setItem('isAuthenticated', 'true');

      const userInfoEndpoint = 'https://api.neontradepro.com/user/info';
      const userInfoResponse = await fetch(userInfoEndpoint, {
        headers: { 'Authorization': `Bearer ${access_token}` }
      });

      const userInfoData = await userInfoResponse.json();
      if (!userInfoResponse.ok) {
        throw new Error('خطا در دریافت اطلاعات کاربر.');
      }

      if (userInfoData.username) {
        localStorage.setItem('username', userInfoData.username);
      } else {
        localStorage.removeItem('username');
      }

      let isAdmin = false;
      if (userInfoData.admin) {
        localStorage.setItem('isAdmin', 'true');
        isAdmin = true;
      } else {
        localStorage.removeItem('isAdmin');
      }

      if (isAdmin) {
        navigate('/admin', { replace: true });
      } else {
        navigate('/dashboard', { replace: true });
      }

      window.location.reload();

    } catch (err) {
      localStorage.removeItem('token');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('isAdmin');
      const errorMessage = (err instanceof Error ? err.message : 'خطا در ارتباط با سرور.');
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormWrapper
      title="ورود به حساب کاربری"
      subtitle="برای دسترسی به پنل کاربری خود، لطفاً وارد شوید."
      currentStep={1}
      totalSteps={1}
    >
      <form onSubmit={handleSubmit} autoComplete="off">
        {error && <div className="error-message">{error}</div>}

        <div className="input-group">
          <label htmlFor="identifier">نام کاربری یا ایمیل</label>
          <input
            type="text"
            id="identifier"
            name="identifier"
            value={form.identifier}
            onChange={handleChange}
            required
            autoFocus
            placeholder="نام کاربری یا ایمیل خود را وارد کنید"
            disabled={loading}
          />
        </div>

        <div className="input-group">
          <label htmlFor="password">رمز عبور</label>
          <input
            type={showPassword ? "text" : "password"}
            id="password"
            name="password"
            value={form.password}
            onChange={handleChange}
            required
            placeholder="رمز عبور خود را وارد کنید"
            disabled={loading}
          />
        </div>

        <div className='input-group' style={{ marginTop: '0.5rem', marginBottom: '1rem', display: 'flex', alignItems: 'center', direction: 'rtl' }}>
          <input
              type="checkbox"
              id="showPassword"
              checked={showPassword}
              onChange={() => setShowPassword(!showPassword)}
              style={{ width: 'auto', marginLeft: '0.5rem' }}
          />
          <label htmlFor="showPassword" style={{ fontWeight: 'normal', fontSize: '0.875rem', marginRight: '0.25rem' }}>نمایش رمز عبور</label>
        </div>

        <button type="submit" className="main-btn" disabled={loading} style={{width: '100%', marginTop: '1rem'}}>
          {loading ? 'در حال ورود...' : 'ورود'}
        </button>

        <div className="form-footer">
          <Link to="/forgot-password">فراموشی رمز عبور؟</Link>
        </div>
        <div className="form-footer">
          <span>حساب کاربری ندارید؟</span>
          <Link to="/signup">ثبت نام کنید</Link>
        </div>
      </form>
    </FormWrapper>
  );
};

export default LoginForm;